import { Box } from "@chakra-ui/react"
import React from "react"

export const SearchStatsWrapper = ({ children }) => {
  return <Box className="stats">{children}</Box>
}
